import React from 'react';
import IconName from "../../../svgLogo/SvgLogo";

const AddressSend = () => {
    return (
        <div className="address-send-wrapper">
            <div className="title xmb-4">
                <div className="title-box just-text title-box-blue">
                    <div className="title-bg">
                        <h2 className="text">
                            آدرس تحویل سفارش
                        </h2>
                    </div>
                </div>
            </div>
            <div
                className="received-address xmb-6 xmb-lg-8 d-flex align-items-start align-items-lg-center justify-content-start justify-content-lg-between">
                <span className="name d-none d-lg-inline-block">آدرس تحویل سفارش</span>
                <IconName name="location" className="icon d-inline-block d-lg-none"/>
                <span
                    className="text">آذربایجان شرقی، تبریز، کوی گلشهر، خیابان گلگشت شرقی، پلاک ۵۱، طبقه‌ی ۴.</span>
            </div>
        </div>
    );
};

export default AddressSend;
